export default class HTTP {

	responseHandler (request, details){
		let callbackData = (details.callbackData) ? details.callbackData : {  };

		return function () {
			if (this.readyState === 4) {
				if (this.status === 200) {
					if (typeof details.onSuccess === 'function') {
						details.onSuccess(this.responseText, callbackData);
					}
				} else {
					if (typeof details.onFailure === 'function') {
						details.onFailure(this.status, callbackData, this.responseText);
					}
				}
			}
		};
	}

	/**
	 *  Performs a HTTP GET request
	 *
	 *  The details object can contain the properties:
	 *  	url - The URL to make the request to.
	 *  	timeout - The timeout to use for the connection in ms.
	 *  	onSuccess - A function to call when the request completes, with the response text as a parameter.
	 *  	onFailure - A function to call if the request fails, with the HTTP status code as a parameter.
	 *
	 *  @param details details The request details.
	 */
	get (details) {
		let request = new XMLHttpRequest();
		let handler = this.responseHandler(request, details);

		request.addEventListener('readystatechange', handler, false);

		try {
			request.timeout = (details.timeout) ? details.timeout : 0;
		} catch (e){}

		request.open('GET', details.url, true);
		request.send(null);
	}

	/**
	 *  Performs a HTTP POST request.
	 *
	 *  The details object can contain the properties:
	 *  	url - The URL to make the request to.
	 *  	timeout - The timeout to use for the connection in ms.
	 *  	data - A FormData object.
	 *  	onSuccess - A function to call when the request completes, with the response text as a parameter.
	 *  	onFailure - A function to call if the request fails, with the HTTP status code as a parameter.
	 *  	onProgress - A function to call when the response progress is updated,
	 *  	with the size received and set as parameters.
	 *  	onUploadProgress - A function to call when the request progress is updated,
	 *  	with the size received and set as parameters.
	 *
	 *  @param details details The request details.
	 */
	post (details) {
		let request = new XMLHttpRequest();
		let callbackData = (details.callbackData) ? details.callbackData : {  };
		let handler = this.responseHandler(request, details);

		request.addEventListener('readystatechange', handler, false);

		try {
			request.timeout = (details.timeout) ? details.timeout : 0;
		} catch (e){}

		if (details.onProgress) {
			request.addEventListener('progress', function (event) {
				details.onProgress(event.loaded, event.total, callbackData);
			}, false);
		}

		if (details.onUploadProgress) {
			request.upload.addEventListener('progress', function (event) {
				details.onUploadProgress(event.loaded, event.total, callbackData);
			}, false);
		}

		request.open('POST', details.url, true);

		// timeout stops ie from randomly crapping out :S
		setTimeout(function () {
			request.send((details.data) ? details.data : null);
		}, 0);
	}

}
